import { Component, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MdlRescheduleCampaign } from '../mdl-reschedule-campaign/mdl-reschedule-campaign';
import { Api } from '../../services/api';

@Component({
  selector: 'app-mdl-change-campaign-status',
  imports: [],
  templateUrl: './mdl-change-campaign-status.html',
  styleUrl: './mdl-change-campaign-status.css'
})
export class MdlChangeCampaignStatus implements OnInit {

  private api = inject(Api);
  public statusList: any = [];

  constructor(    
    public mdl: MatDialogRef<MdlRescheduleCampaign>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){

  }

  ngOnInit(): void {
    this.getCampaignStatus(); 
  }

  getCampaignStatus(){
    this.api.getStatusByType({tipo: 'CMP'}).subscribe({
      next: (response:any) => {
        this.statusList = response.data;
      },
      error: (error) => {
        console.error('Error fetching campaign status:', error);
      }
    });
  }

  closeMdl(){
    this.mdl.close();
  }
  
  saveStatus(){
    
  }
}
